import script from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=js"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=172ac784&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172ac784"]])

export default __exports__